import { Shark } from "shark-mvc";

import  { Driver } from "Models/Driver";
import { driverManager } from "Managers/driverManager";

import templateContent from "Templates/views/vehicle-pick-up.html";
import { refuelEditView } from "./refuelEditView";
import { mainNavComponent } from "../../components/mainNav/mainNavComponent";
import { vehicleActivityManager } from "../managers/vehicleActivityManager";
import { homeView } from "./homeView";

var vehiclePickUpView = Shark.createJaw("vehiclePickUpView");

vehiclePickUpView.templateContent = templateContent;
vehiclePickUpView.route = "vehicle-pickup";

vehiclePickUpView.addMethod("beforeLoad", function () {
	Shark.set({
		currVehicleActivity: Shark.getInstance("VehicleActivity", {
			type: "pick-up"
		})
	});

	navigator.geolocation.getCurrentPosition((data) => {
		const coords = {
			accuracy: data.coords.accuracy,
			altitude: data.coords.altitude,
			altitudeAccuracy: data.coords.altitudeAccuracy,
			heading: data.coords.heading,
			latitude: data.coords.latitude,
			longitude: data.coords.longitude,
			speed: data.coords.speed,
		}
		// console.log("success", {data}, arguments);
		// accuracy: 1228
		// altitude: null
		// altitudeAccuracy: null
		// heading: null
		// latitude: 45.6548352
		// longitude: 9.6813056
		// speed: null
		console.warn(data.coords)
		Shark.set("currGeoLocation", coords);
		Shark.get("currVehicleActivity").set("geo", coords);

		console.log(JSON.stringify(coords));
	},
	(data) => {
		console.log("", {data}, arguments);
	}); 
});

vehiclePickUpView.addMethod("init", function () {
	this.addComponents([mainNavComponent]);
});

vehiclePickUpView.addMethod("saveBtn_clickHandler", function () {
	const currVehicleActivity = Shark.get("currVehicleActivity");

	console.log(currVehicleActivity)

	vehicleActivityManager.save(currVehicleActivity);
});

vehiclePickUpView.addMethod("vehicleActivityManager_savedHandler", function () {
	Shark.openPage(homeView);
});

Shark.registerView(vehiclePickUpView);

export { vehiclePickUpView };
